import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'query-string';
import _get from 'lodash/get';
import ReactIframeResizer from 'react-iframe-resizer-super';

const DEFAULT_HEIGHT = 45;
const MAX_VISIBLE = 5;
const SPACE_BETWEEN_DROPDOWN_AND_INPUT = 7;
const EXTRA_PADDING_BOTTOM = 12; // for showing the warning text

// prevent the dropdown overlapse the input search
const calcDropdownHeight = (height, maxVisible) =>
  (height + SPACE_BETWEEN_DROPDOWN_AND_INPUT) * maxVisible * 2;

export const getWidgetID = () => `SegPWidget-${Date.now()}`;
export default class SegPWidget extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownVisible: false,
    };
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('message', this.handleFrameTasks);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }

  handleFrameTasks = event => {
    // if (event.source.document !== this.iframeRef.current.contentDocument) {
    //   return;
    // }
    const eventWidgetID = _get(event, 'data.widgetID', '');

    if (eventWidgetID !== this.state.widgetID) return;

    const { data } = event;
    const messageType = _get(data, 'type', '');
    switch (messageType) {
      case 'selected_segment':
        this.props.onSelect(data.segment);
        break;

      case 'onVisibleDropdown':
        this.setState({ dropdownVisible: data.visible });
        break;

      case 'deselected_segment':
        this.props.onDeselect(data.segment);
        break;

      case 'selected_segments':
        this.props.onSelectionChange(data.segments);
        break;

      case 'on_input_change':
        this.props.onInputChange(data.value);
        break;

      default:
        break;
    }
  };

  formatParams = (restProps = {}) => {
    const { src } = this.props;

    let widgetID = this.state.widgetID;
    if (!widgetID) {
      widgetID = getWidgetID();
      this.setState({ widgetID });
    }

    const stringifiedParams = stringify({
      ...restProps,
      widgetID,
    });

    return `${src}?${stringifiedParams}`;
  };

  renderSimpleMode = () => {
    const { id, style, ...rest } = this.props;

    Object.keys(rest).forEach(item => {
      if (typeof rest[item] === 'function' || rest[item] === undefined) {
        delete rest[item];
      }
    });

    delete rest.src;

    const dropdownHeight = calcDropdownHeight(rest.height, rest.maxVisible);
    return (
      <iframe
        ref={this.iframeRef}
        title="SegP Widget"
        src={this.formatParams(rest)}
        id={id}
        frameBorder={0}
        style={{
          minHeight:
            rest.height +
            SPACE_BETWEEN_DROPDOWN_AND_INPUT +
            EXTRA_PADDING_BOTTOM,
          zIndex: 1010,
          ...style,
          position: 'absolute',
          top: 2,
          height: this.state.dropdownVisible
            ? dropdownHeight
            : rest.height +
              SPACE_BETWEEN_DROPDOWN_AND_INPUT +
              EXTRA_PADDING_BOTTOM,
        }}
      />
    );
  };

  render() {
    const { id, mode, ...rest } = this.props;
    const iframeResizerOptions = {
      checkOrigin: false,
      heightCalculationMethod: 'lowestElement',
      widthCalculationMethod: 'rightMostElement',
    };
    const advancedMode = mode === 'advanced';
    return advancedMode ? (
      <ReactIframeResizer
        id={id}
        iframeResizerOptions={iframeResizerOptions}
        {...rest}
        src={this.formatParams()}
      />
    ) : (
      this.renderSimpleMode()
    );
  }
}

SegPWidget.propTypes = {
  src: PropTypes.string.isRequired,
  id: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  searchType: PropTypes.string,
  mode: PropTypes.string,
  height: PropTypes.number,
  maxVisible: PropTypes.number,
  appMode: PropTypes.string,
  namespace: PropTypes.string,
  showNsDropdown: PropTypes.bool,
  defaultValue: PropTypes.string,
  onSelect: PropTypes.func,
  onInputChange: PropTypes.func,
  selection: PropTypes.string,
  onDeselect: PropTypes.func,
  onSelectionChange: PropTypes.func,
  enabledSegmentNSFormat: PropTypes.bool,
  showFilter: PropTypes.bool,
};

SegPWidget.defaultProps = {
  id: 'segp-widget',
  style: {},
  searchType: 'segment',
  mode: 'simple',
  height: DEFAULT_HEIGHT,
  maxVisible: MAX_VISIBLE,
  appMode: 'pax',
  namespace: 'all',
  showNsDropdown: false,
  defaultValue: '',
  onSelect: () => {},
  onInputChange: () => {},
  selection: 'single',
  onDeselect: () => {},
  onSelectionChange: () => {},
  enabledSegmentNSFormat: false,
  showFilter: false,
};

SegPWidget.displayName = 'SegPWidget';
